import { useMemo } from 'react'

import { Provider, type ProviderProps } from './uiContext'
import { useThemeContext } from './useThemeContext'

/** Context Provider for the Life portal settings.  */
const UiProvider = ({ children, ...props }: ProviderProps) => {
  const themeContext = useThemeContext()

  const value = useMemo(
    () => ({
      ...props,
      ...themeContext,
    }),
    [props, themeContext],
  )

  return (
    <Provider value={value}>
      {typeof children === 'function' ? children(value) : children}
    </Provider>
  )
}

export { UiProvider }
